export function intercomProxy(window) {
  return function proxy(...args) {
    if (!window.Intercom) {
      window.console.warn('Intercom not loaded.');
      return;
    }
    try {
      return window.Intercom(...args);
    } catch (e) {
      window.console.error(e);
    }
  };
}

export default intercomProxy(window);
